export default {
  'wp-content-frame': {
    name: 'Content frame',
    settings: {
      header: 'Header',
      source: 'Source url'
    }
  }
}
